package main.kotlin.ui

import org.w3c.dom.Document
import org.w3c.dom.HTMLHRElement

open class Hr(document: Document, id:String) : Element(document,id,"block")
{
    override val view : HTMLHRElement = document.getElementById(id) as HTMLHRElement
}
